// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\ReleaseNoteResponse

import { ReleaseNoteType, ReleaseNoteReactionType } from './enums.gen';
import { hydrateReleaseNoteReactions, type ReleaseNoteReactions, type ReleaseNoteReactionsApiResponse } from './releaseNoteReactions.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type ReleaseNoteApiResponse = {
	id: number;
	title: string;
	description: string;
	type: ReleaseNoteType;
	link: string | null;
	publishedAt: string;
	reactions: ReleaseNoteReactionsApiResponse;
	userReaction: ReleaseNoteReactionType | null;
};

export type ReleaseNote = {
	id: number;
	title: string;
	description: string;
	type: ReleaseNoteType;
	link: string | null;
	publishedAt: DateTime;
	reactions: ReleaseNoteReactions;
	userReaction: ReleaseNoteReactionType | null;
};

export function hydrateReleaseNote(data: ReleaseNoteApiResponse): ReleaseNote {
	return {
		...data,
		publishedAt: DateTimefromISO(data.publishedAt)!,
		reactions: hydrateReleaseNoteReactions(data.reactions),
	};
}